// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_button__4-vvU {
  border-radius: 72px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: linear-gradient(90deg, #ff4926 0%, #ef593c 100%);
  /* Button Shadows */
  box-shadow: 0px 94px 26px 0px rgba(0, 0, 0, 0),
    0px 60px 24px 0px rgba(0, 0, 0, 0.01), 0px 34px 20px 0px rgba(0, 0, 0, 0.05),
    0px 15px 15px 0px rgba(0, 0, 0, 0.09), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  gap: 2px;
}

.button_special__CkUek {
  background: var(
    --Baniclub-Linear-Gradient,
    linear-gradient(86deg, #ffa800 28.29%, #db7600 99.23%)
  );
}

.button_button__4-vvU span {
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.button_img__RInS- {
  width: 24px;
  height: 24px;
}
.button_outline__oSx\\+1 {
  border: 2px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.1);
}
.button_outline__oSx\\+1 span {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/button/button.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,4DAA4D;EAC5D,mBAAmB;EACnB;;6EAE2E;EAE3E,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE;;;GAGC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2CAA2C;EAC3C,oCAAoC;AACtC;AACA;EACE,WAAW;AACb","sourcesContent":[".button {\n  border-radius: 72px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: linear-gradient(90deg, #ff4926 0%, #ef593c 100%);\n  /* Button Shadows */\n  box-shadow: 0px 94px 26px 0px rgba(0, 0, 0, 0),\n    0px 60px 24px 0px rgba(0, 0, 0, 0.01), 0px 34px 20px 0px rgba(0, 0, 0, 0.05),\n    0px 15px 15px 0px rgba(0, 0, 0, 0.09), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);\n  gap: 8px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 56px;\n  gap: 2px;\n}\n\n.special {\n  background: var(\n    --Baniclub-Linear-Gradient,\n    linear-gradient(86deg, #ffa800 28.29%, #db7600 99.23%)\n  );\n}\n\n.button span {\n  color: #fff;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.img {\n  width: 24px;\n  height: 24px;\n}\n.outline {\n  border: 2px solid rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.1);\n}\n.outline span {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button_button__4-vvU`,
	"special": `button_special__CkUek`,
	"img": `button_img__RInS-`,
	"outline": `button_outline__oSx+1`
};
export default ___CSS_LOADER_EXPORT___;
